export const AUTH_TOKEN = 'Authorization';

export const LOCAL_STORAGE = {
  ID_TOKEN: 'token',
  USER: 'user',
};

export const HOME_PATH = '/';
export const SITE_URL = 'https://buffstream.st';
export const SITE_NAME = 'Buffstreams';
export const SITE_DOMAIN = 'buffstream.st';

export const PAGE_TITLES: any = {
  WEBSITE_TITLE: 'Buffstreams – Live Sports Streaming for NBA, NFL, Boxing, MMA, and F1',
  SOCCER: 'Live Soccer Streams & Football Fixtures – Premier League, Champions League | Buffstreams',
  BOXING: 'Free Boxing Live Streams & Upcoming Fight Schedules | Buffstreams',
  NFL: 'Free NFL Live Streams – Every Game, Playoffs & Super Bowl | Buffstreams',
  NBA: 'Free NBA Live Streams – Regular Season & Playoffs in HD | Buffstreams',
  UFC: 'Free UFC Live Streams – Fight Night & PPV Events | Buffstreams',
  MMA: 'Free MMA & UFC Live Streams – Fight Night & PPV Coverage | Buffstreams',
  TENNIS: 'Live Tennis Streams & Match Fixtures | Buffstreams',
  RUGBY: 'Free Rugby Live Streams & Match Schedules | Buffstreams',
  MOTOGP: 'Free MotoGP Live Streams & Race Schedules | Buffstreams',
  NHL: 'Free NHL Live Streams & Game Fixtures | Buffstreams',
  MLB: 'Free MLB Live Streams & Season Schedules | Buffstreams',
  F1: 'Free F1 Live Streams – Grand Prix & Race Coverage | Buffstreams',
  MLS: 'Free MLS Live Streams & Match Fixtures | Buffstreams',
  CRICKET: 'Live Cricket Streams – PSL, IPL, T20, ODI & Test Matches | Buffstreams',
  NASCAR: 'Free NASCAR Live Streams & Race Schedules | Buffstreams',
  CONTACT: 'Contact Buffstreams – Feedback & Support',
  ABOUT: 'About Buffstreams – Free Live Sports Streaming Platform'
}

export const categories = [
  {
    label: 'Soccer',
    value: 'Soccer'
  },
  {
    label: 'F1',
    value: 'F1'
  },
  {
    label: 'Tennis',
    value: 'tennis'
  },
  {
    label: 'Boxing',
    value: 'Boxing'
  },
  {
    label: 'UFC',
    value: 'UFC'
  },
  {
    label: 'Motogp',
    value: 'motogp'
  },
  {
    label: 'NFL',
    value: 'NFL'
  },
  {
    label: 'NBA',
    value: 'NBA'
  },
  {
    label: 'MMA',
    value: 'UFC'
  },
  {
    label: 'NHL',
    value: 'NHL'
  },
  {
    label: 'Rugby',
    value: 'Rugby'
  },
  // {
  //   label: 'Cricket',
  //   value: 'cricket'
  // }
  {
    label: 'MLB',
    value: 'MLB'
  },
  {
    label: 'MLS',
    value: 'MLS'
  }
];

export const MESSAGES = {
  EMAIL_SUCCESS: 'Your email has been sent successfully!',
  EMAIL_FAILURE: 'Unable to sent email!',
  ADD_STREAM_SUCCESS: 'Player added successfully!',
  ADD_STREAM_FAILURE: 'Failed to add player!',
  UPDATE_STREAM_SUCCESS: 'Streams updated successfully!',
  UPDATE_STREAM_FAILURE: 'Failed to add sreeams!',
  AUTH_SUCCESS: 'User Authenticated!',
  AUTH_FAILURE: 'Invalid user or password!'
}

export const LOGO_URL = '';

export const MENU_CATEGORIES = [
  {
    label: 'Soccer',
    value: 'Soccer'
  },
  {
    label: 'NFL',
    value: 'nfl'
  },
  {
    label: 'F1',
    value: 'F1'
  },
  {
    label: 'NBA',
    value: 'nba'
  },
  {
    label: 'Boxing',
    value: 'Boxing'
  },
  {
    label: 'MMA/UFC',
    value: 'mma'
  },
  {
    label: 'Motogp',
    value: 'MOTOGP'
  },
  {
    label: 'Rugby',
    value: 'Rugby'
  }
  // {
  //   label: 'WWE',
  //   value: 'WWE'
  // },
];

export const CATEGORY_LINKS:any = {
  SOCCER: 'Soccer',
  NFL: 'nfl',
  F1: 'F1',
  NBA: 'nba',
  BOXING: 'Boxing',
  UFC: 'ufc',
  NHL: 'nhl',
  MLS: 'mls',
  MLB: 'mlb',
  MOTOGP: 'MOTOGP',
  RUGBY: 'Rugby',
  TENNIS: 'tennis',
  NASCAR: 'NASCAR',
  WWE: 'WWE'
};

export const ADS = {
  MAIN: {
    TYPE: 'main',
    SLOT: '2554300823'
  },
  FIXTURE_LIST_DISPLAY_HORIZONTAL: {
    TYPE: 'FixtureListDisplayHorizontal',
    SLOT: '3824669050'
  },
  PLAYER_DISPLAY_HORIZONTAL: {
    TYPE: 'playerDisplayHorizontal',
    SLOT: '3744778007'
  },
  VERTICLE_MAIN: {
    TYPE: 'vertical',
    SLOT: '2926488530'
  },
  IN_ARTICLE: {
    TYPE: 'in-article',
    SLOT: '6685754230'
  },
  IN_FEED: {
    TYPE: 'in-feed',
    SLOT: '2184823320'
  },
  SQUARE_DISPLAY: {
    TYPE: 'square-display',
    SLOT: '7807264218'
  },
}

export const DEFAULT_LEAGUE_LINK = '/leagues/Premier League/645bec5ba42012fa6eb37334';
export const DEFAULT_TEAM_LINK = '/teams/Liverpool/6455eab25477a7f3d047a4cc';

export const SPORTS_CATEGORIES = [
  {
  label: 'Soccer',
  value: 'Soccer',
  },
  {
    label: 'UFC',
    value: 'mma',
  },
  {
    label: 'mma',
    value: 'ufc',
  },
  {
    label: 'F1',
    value: 'f1',
  },
  {
    label: 'MOTOGP',
    value: 'motogp',
  },
]

export const DIRECT_PLAYERS = [
  'TNT SPORTS FHD'
];

export const IMAGE_PROXY_URL = process.env.REACT_APP_IMAGE_PROXY_URL || 'https://streameast7.org';

export const STREAMERS = ['freesport'];
export const REDDIT_STREAM = 'redditstream';
export const GREEN_PLAYER_SOURCES = ['Reddit-SoccerStreams', 'Reddit-Streams', 'Reddit-SoccerSt...']

export const OTHER_CATEGORIES = ['tennis', 'Cricket', 'F1', 'Boxing', 'nhl', 'nba', 'mls', 'mlb', 'MOTOGP'];